import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr} from '../utils.js'
import UniTreeTable from '../cmp/UniTreeTable'
import FilterForm from '../cmp/FilterForm' //+
import Menu from '../cmp/menu'
import icon from '../icons.svg'

function CatMenuGrpList({data=undefined,actions,choice=false}){
    const type='catMenuGrp'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    //const getGlData=actions.getGlData

    if(wndData!==''&&wndData.ierarc===undefined) wndData.ierarc=1

    const context=useContext(dataContext)
    const Data=context.data[type]
    const DataFld=context.data['fldMenuGrp']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const glStatus=context.status

    const cols=[
        {caption:'icon',minWidth:'24',dataId:'catFolderAO',sortable:false},
        {caption:'id',minWidth:'8',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'80',dataId:'name',sortable:true},
        {caption:localestr('Сортування'),minWidth:'8',dataId:'sorting',sortable:true}
    ]

    const filterData=[ //+
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    /*const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        let ierarc=1
        if(showAFilter) ierarc=0
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(!showAFilter) setWndData({...wndData,ierarc,filter:undefined,showAFilter})
        else setWndData({...wndData,ierarc,showAFilter})
    }*/


    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            //const newItem={id:item.id,name:item.name,fio:item.fio,marked:item.marked}
            const newItem={...item}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const editItem=()=>{
        if (typeof wndData.currentCol === 'object'){
            if(wndData.currentCol.isfolder) tabNew('fldMenuGrp_edit',localestr('Папка')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol})
            else tabNew('catMenuGrp_edit',localestr('Категорія')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol})
        }
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) fldClick(wndData.currentCol,0)
            else if(choice===2) {tabChoice(wndData.currentCol)}
            else if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            if (wndData.currentCol.isfolder) {
                let newData={status:'rem',key:'FldMenuGrp',data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
                saveData(newData,()=>{})
            }
            else {
                let newData={status:'rem',key:type,data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
                saveData(newData,()=>{})
            }
        }
    }

    const transferItem=(item,target)=>{
        if (typeof item === 'object') {
            let newData={status:'mod',key:(item.isfolder?'FldMenuGrp':'CatMenuGrp'),data:{...item,parent:target}}
            saveData(newData,()=>{})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        //setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        setWndData({...wndData,showFilter,filter})
    }

    const newItem=()=>{tabNew('catMenuGrp_edit',localestr('Категорія')+' *',{parent:wndData.currentFld})}

    const copyItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            let item={...wndData.currentCol}
            delete item.id
            tabNew('catMenuGrp_edit',localestr('Категорія')+' *',item)
        }
    }

    const fldClick=(fld,ch=1)=>{
        //console.log('fldClick')
        if(!wndData.currentFld) setWndData({...wndData,currentFld:fld})
        else if(wndData.currentFld.id===fld.id&&ch===0) setWndData({...wndData,currentFld:fld.parent})
        else setWndData({...wndData,currentFld:fld,currentCol:undefined})
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:type}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }
        
    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') tabNew('catMenuGrp_edit',localestr('Категорія')+' *')
        else if(key==='shift_Insert') tabNew('fldMenuGrp_edit',localestr('Папка')+' *')
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
    }

    const hDragDrop=(item,target)=>{
        if(item.isfolder && item.id===target.id) return
        if(item.parent.id===target.id) return
        if(item.id===target.parent.id) return
        if(target.parent.parent) {
            if(item.id===target.parent.parent.id) return
            if(target.parent.parent.parent) {
                if(item.id===target.parent.parent.parent.id) return
                if(target.parent.parent.parent.parent) {
                    if(item.id===target.parent.parent.parent.parent.id) return
                    
                }
            }
        }
        msg('Перемістити '+item.name+' у '+target.name+'?',localestr('Переміщення'),[{caption:localestr('Так'),action:()=>{transferItem(item,target)}},{caption:localestr('Ні'),action:()=>{}}])
    }

    /*const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }*/

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData(type)
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data,DataFld])

    /*useEffect(() => {
        //console.log('effect2')
        if (typeof Data === 'undefined') return//getData('catUsers')
        else if (typeof wndData==='undefined' || wndData==='') sortList('name','asc')
        //else sortList(wndData.sorting.dataId,wndData.sorting.sort)
    // eslint-disable-next-line 
    },[wndData])*/

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const wndDataFld = typeof DataFld === 'undefined' ? [] : DataFld
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+
    const ierarcBtn = wndData.ierarc ? <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати список')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:0})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:0})}}
                                    ><img src={icon+'#foldBut'} alt={localestr('Показувати список')} /></div> : 
                                    <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати папки')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:1})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:1})}}
                                    ><img src={icon+'#unfoldBut'} alt={localestr('Показувати папки')} /></div>


    const menuData=[
        {name:localestr('Друк списку'),icon:'#prnBut',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData(type)}},
    ]
    if(choice) menuData.splice(0,2)

    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)',width:'100%'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>{newItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('catMenuGrp_edit',localestr('Категорія')+' *')}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати папку')+' (Shift+Ins)'} 
            onClick={()=>{tabNew('fldMenuGrp_edit',localestr('Папка')+' *')}}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('fldMenuGrp_edit',localestr('Папка')+' *')}}><img src={icon+'#fldBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>{editItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{removeItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}  
            onClick={()=>{filter()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') filter()}}><img src={icon+'#filtBut'} alt={localestr('Фільтр')} /></div>
            {ierarcBtn}
            <div style={{flexGrow:'10'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTreeTable haveHeader={true} colsArr={cols} data={wndDataList} folders={wndDataFld} ierarc={wndData.ierarc} currCol={wndData.currentCol} currFld={wndData.currentFld} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} Caption={localestr('Категорії меню')} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} fldHandle={fldClick} openHandle={editClick} keyHandle={anyKey} hDragDrop={hDragDrop} setFilter={setFilter} isActive={isActive()}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatMenuGrpList